import dataService from 'services/dataService';
import { apiCcmPatientDischarge } from 'services/dataService/ccmResources';
import { showResult } from 'infrastructure/hooks/utils';

import type { CcmStatuses } from 'infrastructure/enums';

interface DataProps {
  patientGuid: string;
  dischargeStatus: CcmStatuses;
}

export const updatePatientCcmStatusFn = async (postData: DataProps) => {
  const { error, data } = await dataService.updateOnly(
    apiCcmPatientDischarge(postData.patientGuid),
    { dischargeStatus: postData.dischargeStatus },
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};
